export default __webpack_public_path__ + "static/11-7f3c6819a0aa87c5298ef526442e467a.jpg";